  <div class="container d-flex justify-content-center align-items-center" id="addNotifyFile">
     <div class="modal" tabindex="-1" role="dialog" id="loadFileResult" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body"><span
              class="{{this.messageColor}} text-center font-weight-bold">{{this.message}}</span></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
      <form class="text-center p-4 border rounded" style="width: 100%; max-width: 600px;" (ngSubmit)="onSendNotifyFile()"
        [formGroup]="notifyForm">
        <div class="mb-4 fw-bold">Charger le fichier des destinataires </div>
        <div class="form-group form-floating">
          <input type="hidden" formControlName="idPartner">
          <input type="file" class="ml-2 mr-2 mt-2 mb-2 form-control" #fileNotify accept=".xlsx"
            (change)="onChangeFile($event)" placeholder="Ajouter le fichier des destinataires" >
          <label class="mb-2">Ajouter le fichier des destinataires</label>
        </div>
        <div class="form-group form-floating">
            <input type="text" formControlName="object" class="form-control" id="object">
             <label for ="object">Objet du message</label>
        </div>
        <div class="form-group form-floating mb-3">
          <textarea  rows="5" class="form-control"  formControlName="message" id ="message"></textarea>
         <label class="form-label mb-2" for="message">Veuillez entrer votre message</label>
         
        </div>
        <button type="submit" class="btn btn-primary btn-block mt-3" [disabled]="!this.notifyForm.valid">Valider</button>
      </form>
    </div>